import { msg } from "@lingui/core/macro";

export const intervalCountAtLeastOneRuleMessages = {
	name: msg({ message: "Interval Count At Least One" }),
	description: msg({ message: "Ensures a permit has at least one interval" }),
	errors: {
		noInterval: msg({ message: "There must be at least one interval on a permit" }),
	},
} as const;
